import axios from "axios";
// const serverURL = "http://localhost:9000";
// const adminServerURL = "http://localhost:8000";

const serverURL = "https://api.kvstotalcare.in";
const adminServerURL = "https://api.emipluscare.in";

// const serverURL = "https://kvsapi.hotelhighwayrasoi.in";
// const adminServerURL = "https://api.hotelhighwayrasoi.in";


const postData = async (url, body) => {
  try {
    console.log(JSON.stringify(body));
    var response = await axios.post(`${serverURL}/${url}`, body);
    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

const postDataAdmin = async (url, body) => {
  try {
    console.log(JSON.stringify(body));
    var response = await axios.post(`${adminServerURL}/${url}`, body);
    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

const getData = async (url) => {
  try {
    var response = await axios.get(`${serverURL}/${url}`);
    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

const getDataAdmin = async (url) => {
  try {
    var response = await axios.get(`${adminServerURL}/${url}`);
    var data = response.data;
    return data;
  } catch (e) {
    return null;
  }
};

export { serverURL, postData, getData, getDataAdmin, postDataAdmin };
